import React from 'react';

export default function PlanDetailsHeader() {
  return (
    <>
      <section>
        <h1 className="mb-3">Plan Details</h1>

        <p>Manage your programs and assign your members.</p>
      </section>

      <section>
        <h2>Plan Name</h2>

        <p>
          Let your members take advantage of the resources
          available on our platform. With access to Assessments and Webinars, they can
          stay ahead of industry trends and sharpen their skills.
          They can even buy coaching programs for themselves to further develop
          their skills and knowledge.
        </p>
      </section>
    </>
  );
}
